import Alert from "@material-ui/lab/Alert"
import AlertTitle from "@material-ui/lab/AlertTitle"
import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import { useI18n } from "../hooks"
import { StringMap } from "i18next"
import { ExternalLink } from "react-feather"
import React from "react"
import { useAppDispatch } from "../store"
import { ClearStorageAndAuthState } from "../users/store/actions"

const AccountDeletionSuccess = () => {
  const translations = useTranslations()
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    dispatch(ClearStorageAndAuthState())
  }, [dispatch])

  return (
    <Card variant="outlined" style={{ padding: 24, maxWidth: 600, margin: "auto", marginTop: 48 }}>
      <CardContent>
        <Alert color="success" variant="filled">
          <AlertTitle>{translations.deleteSuccessDialogText}</AlertTitle>
        </Alert>
        <br />
        <br />
        <Typography variant="subtitle1">{translations.deleteSuccessDialogGreetingText}</Typography>

        <CardActions>
          <Button
            style={{ marginLeft: -12 }}
            startIcon={<ExternalLink size={20} />}
            component="a"
            href="https://starbrix.app"
            color="primary"
          >
            starbrix.app
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  )
}

export const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations: t } = useI18n("translation")
  const translations = (t.userSettingsView || {}) as StringMap
  const {
    deleteSuccessDialogTitle = defaults.deleteSuccessDialogTitle,
    deleteSuccessDialogText = defaults.deleteSuccessDialogText,
    deleteSuccessDialogGreetingText = defaults.deleteSuccessDialogGreetingText,
    deleteSuccessDialogCloseButtonLabel = defaults.deleteSuccessDialogCloseButtonLabel,
  } = translations

  return {
    deleteSuccessDialogTitle,
    deleteSuccessDialogText,
    deleteSuccessDialogGreetingText,
    deleteSuccessDialogCloseButtonLabel,
  }
}

const defaultTranslations = {
  deleteSuccessDialogTitle: "Account deletion successful!",
  deleteSuccessDialogText:
    "We have now permanently deleted your user account, along with its projects, tasks, to-dos, calendar events, and all other associated data.",
  deleteSuccessDialogGreetingText: "Thank you for using starbrix. We hope to see you again soon!",
  deleteSuccessDialogCloseButtonLabel: "Close",
}

type Translations = typeof defaultTranslations

export default AccountDeletionSuccess
